import React from "react";

interface Props {
  artist: Artist;
}

export default function ArtistItem(props: Props) {
  const artist = props.artist || ({} as Artist);

  return (
    <div className="text-center">
      <div className="relative flex flex-col justify-end w-full font-bold text-white rounded-full h-28 sm:h-32">
        <img
          src={artist.image?.url || "/angaza-logo.png"}
          alt={artist.name}
          className="object-cover object-center w-full h-full rounded-full"
        />
      </div>

      <p className="mt-2 text-xs font-semibold leading-tight truncate overflow-ellipsis">
        {artist.name}
      </p>
      <p className="text-xs">{artist.songCount || 0} Songs</p>
    </div>
  );
}
